<template>
    <div v-if="model && form">
        <rkm-form
            ref="Form"
        >
            <rkm-area
                type="fieldset"
                title="Profissional Responsável"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="autocompleteRequestParams.usuario"
                            :searchFields="fields.autocomplete.usuario"
                            :validations="validations.usuario"
                            :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                            label="Profissional"
                            placeholder="Digite o nome ou número do conselho profissional"
                            v-model="model.usuario"
                            :disabled="model.exportacao"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Unidade"
                            :options="form.unidades"
                            v-model="model.unidadeId"
                            :validations="validations.unidade"
                            text-field="nomeFantasia"
                            value-field="id"
                            show-default-option
                            :disabled="!model.usuario || model.exportacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            label="Infraestrutura"
                            :options="form.infraestruturas"
                            v-model="model.infraestruturaId"
                            :validations="validations.infraestrutura"
                            text-field="nome"
                            value-field="id"
                            show-default-option
                            :disabled="!model.usuario || model.exportacao"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Equipe"
                            :options="form.equipes"
                            v-model="model.equipeId"
                            :validations="validations.equipe"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            :disabled="!model.usuario || model.exportacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            label="Ocupação"
                            :options="form.ocupacoes"
                            v-model="model.ocupacaoId"
                            :validations="validations.ocupacao"
                            text-field="nome"
                            value-field="id"
                            show-default-option
                            :disabled="!model.usuario || model.exportacao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            label="Data"
                            v-model="model.data"
                            :validations="validations.data"
                            :disabled="model.exportacao"
                            right
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-area
                    title="Profissional Auxiliar"
                    no-margin-top
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :repository="repositories.usuario"
                                :requestQueryStringParams="autocompleteRequestParams.usuarioAuxiliar"
                                :searchFields="fields.autocomplete.usuario"
                                :validations="validations.usuarioAuxiliar"
                                :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                                label="Profissional auxiliar"
                                placeholder="Digite o nome ou número do conselho profissional"
                                v-model="model.usuarioAuxiliar"
                                :disabled="model.exportacao"
                                uppercase
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-select
                                label="Unidade"
                                :options="form.unidadesAuxiliar"
                                v-model="model.unidadeAuxiliarId"
                                :validations="validations.unidadeAuxiliar"
                                text-field="nomeFantasia"
                                value-field="id"
                                show-default-option
                                :disabled="!model.usuarioAuxiliar || model.exportacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-select
                                label="Infraestrutura"
                                :options="form.infraestruturasAuxiliar"
                                v-model="model.infraestruturaAuxiliarId"
                                :validations="validations.infraestruturaAuxiliar"
                                text-field="nome"
                                value-field="id"
                                show-default-option
                                :disabled="!model.usuarioAuxiliar || model.exportacao"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-select
                                label="Equipe"
                                :options="form.equipesAuxiliar"
                                v-model="model.equipeAuxiliarId"
                                :validations="validations.equipeAuxiliar"
                                text-field="descricao"
                                value-field="id"
                                show-default-option
                                :disabled="!model.usuarioAuxiliar || model.exportacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-select
                                label="Ocupação"
                                :options="form.ocupacoesAuxiliar"
                                v-model="model.ocupacaoAuxiliarId"
                                :validations="validations.ocupacaoAuxiliar"
                                text-field="nome"
                                value-field="id"
                                show-default-option
                                :disabled="!model.usuarioAuxiliar || model.exportacao"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Pacientes"
                class="mt-3"
            >
                <rkm-button
                    @click="open()"
                    color="primary"
                    slot="trailing"
                    title="Adicionar"
                    :disabled="model.exportacao"
                    small
                >
                    <rkm-icon icon="plus"/>
                </rkm-button>

                <rkm-table
                    :fields="tableFields"
                    :items="model.atendimentos"
                    hide-filters
                    hide-pagination
                    no-footer-sorting
                >
                    <template v-slot:cell(actions)="{ index }">
                        <rkm-button
                            @click="edit(index)"
                            color="primary"
                            title="Editar"
                            small
                        >
                            <rkm-icon icon="pen" />
                        </rkm-button>

                        <rkm-button
                            @click="handleDestroy(index)"
                            color="danger"
                            title="Excluir"
                            :disabled="model.exportacao"
                            small
                        >
                            <rkm-icon icon="trash"/>
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>
        </rkm-form>

        <Modal
            ref="Modal"
            :model="model"
            :form="form"
        />
    </div>
</template>

<script>
import { repository, error, formats, stringCase, object }  from '@/mixins';
import permissao from '@/enums/atencao-basica/parametrizacao/permissao';
import Modal from './components/Modal'
import { mapActions } from "vuex";
import moment from 'moment'

export default {
    components: {
        Modal
    },
    created() {
        this.repositories = {
            atendimentoDomiciliar: this.getConectaSusRepository('atencaoBasica.atendimentoDomiciliar'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
        }
        this.load()
    },
    data: () => ({
        model: null,
        form: null,
        enums: {
            permissao
        }
    }),
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.ATENDIMENTO_DOMICILIAR,
                    not_usuario_id: this.model.usuarioAuxiliar && this.model.usuarioAuxiliar.id
                        ? this.model.usuarioAuxiliar.id
                        : null,
                },
                usuarioAuxiliar: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    not_usuario_id: this.model.usuario && this.model.usuario.id
                        ? this.model.usuario.id
                        : null,
                },
            }
        },
        validations() {
            return {
                usuario: {
                    required: true
                },
                unidade: {
                    required: true
                },
                infraestrutura: {
                    required: true
                },
                equipe: {
                    required: true
                },
                ocupacao: {
                    required: true
                },
                unidadeAuxiliar: {
                    required: true
                },
                infraestruturaAuxiliar: {
                    required: true
                },
                equipeAuxiliar: {
                    required: true
                },
                ocupacaoAuxiliar: {
                    required: true
                },
                data: {
                    required: true
                }

            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                },
            }
        },
        tableFields() {
            return [
                {
                    key: "pacienteNome",
                    label: "Usuario",
                    fixed: true
                },
                {
                    key: "cns",
                    label: "CNS",
                    fixed: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    fixed: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            if(this.id) {
                this.setLoading()
                this.repositories.atendimentoDomiciliar.edit({
                    id: this.id
                })
                    .then(({ data }) => {
                        this.model = data.model
                        this.form = data.form
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.setLoading()
                this.repositories.atendimentoDomiciliar.create()
                    .then(({ data }) => {
                        this.model =  data.model
                        this.form = data.form
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        open() {

            if (!this.model.ocupacaoId) {

                this.showWarningNotification('É necessário informar a ocupação para incluir um paciente.')

                return
            }

            this.$refs.Modal.open()
        },
        getUnidades() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getUnidades({
                usuario_id: this.model.usuario.id
            })
                .then(({ data }) => {
                    this.form.unidades = data
                    if(data.length == 1) {
                        this.model.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getInfraestruturas({
                usuario_id: this.model.usuario.id,
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {
                    this.form.infraestruturas = data
                    if(data.length == 1) {
                        this.model.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getEquipes({
                usuario_id: this.model.usuario.id,
                infraestrutura_id: this.model.infraestruturaId
            })
                .then(({ data }) => {
                    this.form.equipes = data
                    if(data.length == 1) {
                        this.model.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getOcupacoes({
                usuario_id: this.model.usuario?.id ?? this.model.usuario,
                infraestrutura_id: this.model.infraestruturaId
            })
                .then(({ data }) => {
                    this.form.ocupacoes = data
                    if(data.length == 1) {
                        this.model.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidadesAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getUnidades({
                usuario_id: this.model.usuarioAuxiliar.id
            })
                .then(({ data }) => {
                    this.form.unidadesAuxiliar = data
                    if(data.length == 1) {
                        this.model.unidadeAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturasAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getInfraestruturas({
                usuario_id: this.model.usuarioAuxiliar.id,
                unidade_id: this.model.unidadeAuxiliarId
            })
                .then(({ data }) => {
                    this.form.infraestruturasAuxiliar = data
                    if(data.length == 1) {
                        this.model.infraestruturaAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipesAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getEquipes({
                usuario_id: this.model.usuarioAuxiliar.id,
                infraestrutura_id: this.model.infraestruturaAuxiliarId
            })
                .then(({ data }) => {
                    this.form.equipesAuxiliar = data
                    if(data.length == 1) {
                        this.model.equipeAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoesAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getOcupacoes({
                usuario_id: this.model.usuarioAuxiliar?.id ?? this.model.usuarioAuxiliar,
                infraestrutura_id: this.model.infraestruturaAuxiliarId
            })
                .then(({ data }) => {
                    this.form.ocupacoesAuxiliar = data
                    if(data.length == 1) {
                        this.model.ocupacaoAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(index) {
            this.$refs.Modal.open(index)
        },
        handleDestroy(index) {
            this.model.atendimentos.splice(index, 1)
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(valid) {
                        if(this.id) {
                            this.setLoading()
                            this.repositories.atendimentoDomiciliar.update(this.prepareData())
                                .then(() => {
                                    this.showSaveNotification()
                                    this.$emit('save')
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {
                            this.setLoading()
                            this.repositories.atendimentoDomiciliar.store(this.prepareData())
                                .then(() => {
                                    this.showSaveNotification()
                                    this.$emit('save')
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }
                    }
                })
        },
        prepareData() {
            return this.camelObjectKeysToSnakeRecursive({
                id: this.model.id,
                usuarioId: this.model.usuario?.id,
                equipeId: this.model.equipeId,
                ocupacaoId: this.model.ocupacaoId,
                usuarioAuxiliarId: this.model.usuarioAuxiliar?.id,
                equipeAuxiliarId: this.model.equipeAuxiliarId,
                ocupacaoAuxiliarId: this.model.ocupacaoAuxiliarId,
                data: moment(this.model.data).format('YYYY-MM-DD'),
                atendimentos: this.model.atendimentos.map(atendimento => {
                    atendimento.procedimentos = atendimento.procedimentos.map(procedimento => {
                        return {
                            id: procedimento.id,
                            codigo: procedimento.codigo
                        }
                    })

                    atendimento.ivcf = {
                        desejaPreencher: atendimento.ivcf.desejaPreencher,
                        estadoSaudeGeral: atendimento.ivcf.estadoSaudeGeral,
                        limitacaoCompras: atendimento.ivcf.limitacaoCompras,
                        limitacaoGestaoFinanceira: atendimento.ivcf.limitacaoGestaoFinanceira,
                        limitacaoTarefasDomesticas: atendimento.ivcf.limitacaoTarefasDomesticas,
                        banhoIndependencia: atendimento.ivcf.banhoIndependencia,
                        relatoEsquecimentoPorTerceiros: atendimento.ivcf.relatoEsquecimentoPorTerceiros,
                        esquecimentoPiorando: atendimento.ivcf.esquecimentoPiorando,
                        esquecimentoImpactaAtividades: atendimento.ivcf.esquecimentoImpactaAtividades,
                        humorTristezaDesanimo: atendimento.ivcf.humorTristezaDesanimo,
                        perdaInteresseAtividades: atendimento.ivcf.perdaInteresseAtividades,
                        limitacaoElevarBracos: atendimento.ivcf.limitacaoElevarBracos,
                        limitacaoMotricidadeFina: atendimento.ivcf.limitacaoMotricidadeFina,
                        perdaPesoNaoIntencional: atendimento.ivcf.perdaPesoNaoIntencional,
                        imcAbaixo_22: atendimento.ivcf.imcAbaixo22,
                        panturrilhaAbaixo_31: atendimento.ivcf.panturrilhaAbaixo31,
                        marchaLenta_4mMaior_5s: atendimento.ivcf.marchaLenta4mMaior5s,
                        dificuldadeCaminharImpactoAtividades: atendimento.ivcf.dificuldadeCaminharImpactoAtividades,
                        quedasRecorrentes: atendimento.ivcf.quedasRecorrentes,
                        incontinencia: atendimento.ivcf.incontinencia,
                        problemaVisaoImpactoAtividades: atendimento.ivcf.problemaVisaoImpactoAtividades,
                        problemaAudicaoImpactoAtividades: atendimento.ivcf.problemaAudicaoImpactoAtividades,
                        doencasCronicasMultiplas: atendimento.ivcf.doencasCronicasMultiplas,
                        polifarmacia_5OuMaisMedicamentos: atendimento.ivcf.polifarmacia5OuMaisMedicamentos,
                        internacaoUltimos_6Meses: atendimento.ivcf.internacaoUltimos6Meses,
                    }

                    return atendimento
                }),
            })
        },
    },
    watch: {
        'model.usuario': function(usuario) {
            if(usuario) {
                this.getUnidades()
            }
        },
        'model.unidadeId': function(unidadeId) {
            if(unidadeId) {
                this.getInfraestruturas()
            }
        },
        'model.infraestruturaId': function(infraestruturaId) {
            if(infraestruturaId) {
                this.getEquipes()
                this.getOcupacoes()
            }
        },
        'model.usuarioAuxiliar': function(usuario) {
            if(usuario) {
                this.getUnidadesAuxiliar()
            }
        },
        'model.unidadeAuxiliarId': function(unidadeId) {
            if(unidadeId) {
                this.getInfraestruturasAuxiliar()
            }
        },
        'model.infraestruturaAuxiliarId': function(infraestruturaId) {
            if(infraestruturaId) {
                this.getEquipesAuxiliar()
                this.getOcupacoesAuxiliar()
            }
        }
    },
    mixins: [ repository, error, formats, stringCase, object ],
    props: {
        id: { type: Number, required: false }
    }
}
</script>